import React, {useState, useEffect} from 'react'
import TimelineCircleInActive from "../../../Assets/Images/Timeline-Circle-InActive.svg"
import TimelineCircleActive from "../../../Assets/Images/Timeline-Circle-Active.svg"

const FundariserSidebar = ({titles}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // sm:w-[30%] md:w-[20%] lg:w-[20%] xl:w-[20%]
  return (
    <div className='bg-[#FFFFFF] w-full'>
      <div className='mt-[69.5px] ml-[8%]'>
        {titles?.map((title, index) => 
        <div className='flex justify-start' key={index}>
          <div className='flex flex-col mt-[1%]'>
            <img src={title?.completed == true ? TimelineCircleActive : TimelineCircleInActive}/>
            {index!== titles?.length -1 ? <div className={`lg:w-[2px] sm:w-[1px] h-[20px] ${title?.completed === true ? 'bg-[#00ADEF]': 'bg-[#8C8C8C]'} sm:ml-[0.45rem] mt-1`}></div>: ''}
          </div>
          <span className={`ml-[8%] md:text-[12px] lg:text-[16px] font-[400] ${title?.completed == true ? 'text-[#00ADEF]': 'text-[#8C8C8C]'} `}>{title?.name}</span>
        </div>)}
      </div>
    </div>
  )
}

export default FundariserSidebar;